module.exports = __webpack_public_path__ + "static/media/item-none.7276a0e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecturerInvite/item-none.png
// module id = 2005
// module chunks = 6